import React from 'react';
import { Flex } from '@withjoy/joykit';
import wrapHtmlWithSafeLink from '@shared/components/SafeLink/wrapHtmlWithSafeLink';
import { sanitizeRichTextHtml } from '@shared/utils/sanitizeHtmlContent';

// Renders a VIP rich-text (HTML) description on the guest site. `data-richtext-id` scopes
// wrapHtmlWithSafeLink's link interception to this instance's anchors.
//
// Sanitizes at the render boundary: backend sanitization only covers VIPs written through the
// current API. Legacy descriptions (plain textarea values, Firebase imports) predate it and may
// start with HTML such as `<img src=x onerror=…>`, which `isRichTextContent` treats as rich text —
// so without this they'd execute as live HTML via dangerouslySetInnerHTML instead of escaped text.
// `sanitizeRichTextHtml` keeps the editor's `text-align` styling while stripping the XSS vectors.
const VipDescriptionHtmlBase = ({ id, text }: { id: string; text: string }) => (
  <Flex
    width="100%"
    className="jodit-editor"
    data-richtext-id={id}
    flexDirection="column"
    wordBreak="break-word"
    dangerouslySetInnerHTML={{ __html: sanitizeRichTextHtml(text) }}
  />
);

export const VipDescriptionHtml = wrapHtmlWithSafeLink(VipDescriptionHtmlBase);
